import { useCallback, useEffect, useRef, useState } from 'react';

interface animatedText {
  animatedText: string;
  skipAnimation: () => void;
}

const poemChars = (text: string) => text.split('').concat([].map(() => ''));

export const useTextAnimation = (fullText: string, interval = 20): animatedText => {
  const intervalRef = useRef<ReturnType<typeof setInterval>>();
  const [state, setState] = useState({ text: '', rest: poemChars(fullText) });

  useEffect(() => {
    if (state.rest.length === 0) {
      clearInterval(intervalRef.current);
    }
  }, [state.rest.length]);

  useEffect(() => {
    if (fullText) {
      if (state.rest.length === 0) {
        setState({ text: '', rest: poemChars(fullText) });
      }

      const update = () => {
        setState(({ text, rest }) => {
          if (rest.length === 0) {
            return { text, rest };
          }

          const line = text + rest.shift();
          return { text: line, rest };
        });
      };

      intervalRef.current = setInterval(update, interval);
    } else {
      setState({ text: fullText, rest: [] });
    }
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [fullText, interval]);

  const skipAnimation = useCallback(() => {
    setState({ text: fullText, rest: [] });
    clearInterval(intervalRef.current);
  }, [fullText]);

  return { animatedText: state.text, skipAnimation };
};
